// extracted by mini-css-extract-plugin
module.exports = {"root":"musicianTrackWithEmptyInfoInside_root__3hYeo","label":"musicianTrackWithEmptyInfoInside_label__2YabL"};